import React from "react";
import ReactDOM from "react-dom/client";

import "@/index.css";
import { registerTargetServiceWorker } from "@/serviceWorkerRegistration";

// Dynamic app loading based on REACT_APP_TARGET
const AppTarget = process.env.REACT_APP_TARGET || 'all';

// Lazy load the appropriate app
const getApp = () => {
  switch (AppTarget) {
    case 'public':
      return require('@/apps/public/PublicApp').default;
    case 'admin':
      return require('@/apps/admin/AdminAppStandalone').default;
    case 'members':
      return require('@/apps/members/MembersApp').default;
    default:
      // Default: load all routes (original behavior)
      return require('@/App').default;
  }
};

const App = getApp();

registerTargetServiceWorker(AppTarget);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
